import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Themes } from "util/CommonConstant";
import { getLocalStorage } from "util/CommonUtil";
import OrgSpec from "model/api/OrgSpec.model";

export interface ICommonState {
  mode: Themes;
  ravenVersionInfo?: {
    release_version: string;
    release_date: string;
  };
  smartFormatter: boolean;
  org: OrgSpec | null;
}

const initialState: ICommonState = {
  mode: (getLocalStorage("theme") ?? Themes.SYSTEM) as Themes,
  smartFormatter: (getLocalStorage("smartFormatter") ?? "") === "true",
  org: null,
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setMode: (state: ICommonState, action: PayloadAction<Themes>) => {
      state.mode = action.payload;
    },
    setSmartFormatter: (state: ICommonState, action: PayloadAction<boolean>) => {
      state.smartFormatter = action.payload;
    },
    setRavenVersionInfo: (
      state: ICommonState,
      action: PayloadAction<ICommonState["ravenVersionInfo"]>
    ) => {
      state.ravenVersionInfo = action.payload;
    },
    setOrg: (state: ICommonState, action: PayloadAction<OrgSpec | null>) => {
      state.org = action.payload;
    },
  },
});

export const { setMode, setSmartFormatter, setRavenVersionInfo, setOrg } = commonSlice.actions;

export default commonSlice.reducer;
